import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { Table, Typography, Row, Col, Card } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { Footer } from "antd/lib/layout/layout";

const { Title } = Typography;

const ReportsTable = forwardRef(
  (
    {
      report_type,
      report_name,
      rows,
      startDate,
      endDate,
      total,
      cityName,
      isNotloading,
    },
    ref
  ) => {
    console.log("rows", rows);
    console.log("report_type", report_type);
    const [visible, setVisible] = useState(false);
    const tableRef = useRef(null);

    useImperativeHandle(ref, () => ({
      handleDownloadPDF: async () => {
        setVisible(true);
        await new Promise((resolve) => setTimeout(resolve, 500));

        const element = document.getElementById("view-profile");
        html2canvas(element, { scale: 2 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          pdf.save(`${report_name}`);
          setVisible(false);
          isNotloading();
        });
      },
    }));

    const columnsConfig = {
      arophi_count: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        { title: "पोलिस ठाणे", dataIndex: "policeThane", key: "policeThane" },
        {
          title: "हद्दीतील एकुण आरोपी",
          dataIndex: "totalCriminals",
          key: "totalCriminals",
        },
        {
          title: "निष्क्रिय रेकॉर्ड गणना",
          dataIndex: "totalInactiveCriminals",
          key: "totalInactiveCriminals",
        },
        {
          title: "पो.स्टे.नी भरलेली माहिती",
          dataIndex: "allTotalCriminalsbyUser",
          key: "allTotalCriminalsbyUser",
        },
      ],
      गस्त_आकडेवारी: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        { title: "पोलिस ठाणे", dataIndex: "policeThane", key: "policeThane" },
        {
          title: "एकुण आरोपी",
          dataIndex: "totalCriminals",
          key: "totalCriminals",
        },
        {
          title: "एकूण तपासले",
          dataIndex: "totalCriminalsChecked",
          key: "totalCriminalsChecked",
        },
        {
          title: "मिळून आलेला",
          dataIndex: "totalFindCriminals",
          key: "totalFindCriminals",
        },
        {
          title: "मिळून न आलेला",
          dataIndex: "totalUnFindCriminals",
          key: "totalUnFindCriminals",
        },
        {
          title: "उर्वरित आरोपी",
          dataIndex: "remainingCriminals",
          key: "remainingCriminals",
        },
      ],
      चेक_न_आरोपी: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        { title: "नाव", dataIndex: "name", key: "name" },
        {
          title: "आरोपीचे पोलिस ठाणे",
          dataIndex: "districtName",
          key: "districtName",
        },
        {
          title: "Last Update",
          dataIndex: "lastUpdate",
          key: "lastUpdate",
          render: (timestamp) => moment.unix(timestamp).format("DD/MM/YYYY"),
        },
        {
          title: "Count",
          dataIndex: "activeUser",
          key: "activeUser",
        },
        {
          title: "फोटो",
          dataIndex: "photo",
          key: "photo",
          render: (photos) => (photos.length > 0 ? "हो" : "नाही"),
        },
      ],
      app_user: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        {
          title: "पोलिस ठाणे",
          dataIndex: "districtName",
          key: "districtName",
        },
        {
          title: "एकूण App User",
          dataIndex: "cnt",
          key: "cnt",
        },
      ],
      अटक_रजिस्टर: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        {
          title: "आरोपीचे नाव",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "दाखल गुन्हा दिनांक",
          dataIndex: "arrest_dateTime",
          key: "arrest_dateTime",
          render: (timestamp) =>
            moment(timestamp).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
          title: "अटक दिनांक आणि वेळ",
          dataIndex: "court_dateTime",
          key: "court_dateTime",
          render: (timestamp) =>
            moment(timestamp).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
          title: "जन्म दिनांक",
          dataIndex: "criminal_dob",
          key: "criminal_dob",
          render: (timestamp) =>
            moment(timestamp).format("DD/MM/YYYY HH:mm:ss"),
        },
        {
          title: "आधार नंबर",
          dataIndex: "aadharno",
          key: "aadharno",
        },
        {
          title: "फोटो",
          dataIndex: "photo",
          key: "photo",
          render: (photos) => (photos.length > 0 ? "हो" : "नाही"),
        },
      ],
      प्रतिबंधक_कारवाई_count: [
        {
          title: "अ.क्र.",
          key: "index",
          dataIndex: "index",
        },
        {
          title: "पोलिस ठाणे",
          key: "districtName",
          dataIndex: "districtName",
        },
        ...(rows && rows?.length > 0
          ? Object.keys(rows[0])
              .filter((key) => key !== "Sr.No" && key !== "districtName")
              .map((key, index) => ({
                title: key,
                key: `action_${index}`,
                dataIndex: key,
              }))
          : []),
      ],
      प्रतिबंधक_कारवाई_list: [
        { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
        { title: "नाव", dataIndex: "name", key: "name" },
        { title: "वय", dataIndex: "age", key: "age" },
        {
          title: "आरोपीचे पोलिस ठाणे",
          dataIndex: "districtName",
          key: "districtName",
        },
        {
          title: "प्रतिबंधक कारवाई",
          dataIndex: "preventiveActionName",
          key: "preventiveActionName",
        },
        {
          title: "कालावधी पासून",
          dataIndex: "date_from",
          key: "date_from",
          render: (timestamp) => moment(timestamp).format("DD/MM/YYYY"),
        },
        {
          title: "कालावधी पर्यंत",
          dataIndex: "date_to",
          key: "date_to",
          render: (timestamp) => moment(timestamp).format("DD/MM/YYYY"),
        },
        {
          title: "फोटो",
          dataIndex: "photo",
          key: "photo",
          render: (photos) => (photos.length > 0 ? "हो" : "नाही"),
        },
      ],
    };

    const columnsToShow =
      columnsConfig[report_type]?.map((col) => ({
        ...col,
        title: <span style={{ fontSize: "18px" }}>{col.title}</span>,
      })) || [];

    const dataSource =
      rows?.map((item, index) => ({ key: index, index: index + 1, ...item })) ||
      [];

    return (
      <>
        {visible && (
          <div
            id="view-profile"
            ref={tableRef}
            style={{ pointerEvents: visible ? "none" : "auto" }}
          >
            <Card>
              <Row
                justify="center"
                align="middle"
                style={{ marginBottom: 16, textAlign: "center" }}
              >
                <Col>
                  <Title level={3} style={{ fontSize: "24px" }}>
                    (CMIS) - {report_name} - {cityName}
                  </Title>
                  {startDate && (
                    <Title
                      level={5}
                      style={{ fontSize: "20px", marginBottom: 8 }}
                    >
                      From : {moment(startDate).format("DD/MM/YY")}{" "}
                      {endDate && (
                        <>to : {moment(endDate).format("DD/MM/YY")}</>
                      )}
                    </Title>
                  )}
                  {(report_type != "प्रतिबंधक_कारवाई_count" ||
                    report_type != "प्रतिबंधक_कारवाई_list") && (
                    <Title
                      level={5}
                      style={{ fontSize: "20px", marginBottom: 8 }}
                    >
                      एकुण आरोपी:{total}
                    </Title>
                  )}
                </Col>
              </Row>
              <Table
                columns={columnsToShow}
                dataSource={dataSource}
                pagination={false}
                bordered
                style={{ fontSize: "18px" }}
              />
              <Footer
                style={{ textAlign: "center", backgroundColor: "transparent" }}
              >
                <Title style={{ fontSize: "14px", marginBottom: 8 }}>
                  Generated At {moment(new Date()).format("DD MMM YYYY")} From
                  Criminal Monitoring Intelligent System
                </Title>
              </Footer>
            </Card>
          </div>
        )}
      </>
    );
  }
);

export default ReportsTable;
